module.exports = __webpack_public_path__ + "img/circle3.8c5c95ad.svg";